import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import firebaseClientDefaults from "./firebaseClientDefaults.json";
import { getFirebaseAppCheckConfig } from "./firebaseAppCheckConfig";
import {
  assertProductionFirebaseConfig,
  getLocalFirebaseEmulatorConfig,
} from "./localFirebaseSafety";

// Firebase web configuration identifies the public client project; it is not a
// server credential. Environment variables can override these production
// defaults for previews and local emulator projects.

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    firebaseClientDefaults.apiKey,
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    firebaseClientDefaults.authDomain,
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID || firebaseClientDefaults.projectId,
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    firebaseClientDefaults.storageBucket,
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ||
    firebaseClientDefaults.messagingSenderId,
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    firebaseClientDefaults.appId,
};

assertProductionFirebaseConfig(process.env, firebaseConfig);
const emulatorConfig = getLocalFirebaseEmulatorConfig(process.env, firebaseConfig);
const appCheckConfig = getFirebaseAppCheckConfig(
  process.env,
  firebaseConfig,
  emulatorConfig,
);
const app = initializeApp(firebaseConfig);

// Initialise before Auth, Firestore, Storage and Functions so supported
// requests can attach App Check tokens from their first network call.
export const appCheck = appCheckConfig
  ? initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(appCheckConfig.siteKey),
      isTokenAutoRefreshEnabled: appCheckConfig.isTokenAutoRefreshEnabled,
    })
  : null;

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west2");

if (emulatorConfig) {
  connectAuthEmulator(
    auth,
    `http://${emulatorConfig.host}:${emulatorConfig.authPort}`,
    { disableWarnings: true },
  );
  connectFirestoreEmulator(
    db,
    emulatorConfig.host,
    emulatorConfig.firestorePort,
  );
  connectStorageEmulator(storage, emulatorConfig.host, emulatorConfig.storagePort);
  connectFunctionsEmulator(functions, emulatorConfig.host, emulatorConfig.functionsPort);
}
